export function openFromRow(event: { currentTarget: HTMLElement }) {
  const rect = (
    event.currentTarget.closest('tr') || event.currentTarget
  ).getBoundingClientRect()
  document.documentElement.style.setProperty(
    '--detail-origin-x',
    `${rect.left + rect.width / 2 - window.innerWidth / 2}px`,
  )
  document.documentElement.style.setProperty(
    '--detail-origin-y',
    `${rect.top + rect.height / 2 - window.innerHeight / 2}px`,
  )
}
